export enum UserRole {
    Admin = "Admin",
    SME = "SME",
    Leadership = "Leadership",
    Operation = "Operation",
  }
  